import { Link } from "react-router-dom";

import { LogoMark } from "../../brand/Logo";

/** Wordmark plus the drawn skyline mark, shared by the header and footer. */
export function Brand({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={`brand${className ? ` ${className}` : ""}`}
      aria-label="Indraprastha Engineers and Architects — home"
    >
      <LogoMark height={42} reversed className="brand__mark" />
      <span>
        <span className="brand__name">Indraprastha</span>
        <span className="brand__tag">Engineers &amp; Architects</span>
      </span>
    </Link>
  );
}
